import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Dayjs } from "dayjs"; // Import Dayjs type
import { styled } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import IconButton from "@mui/material/IconButton";
import { DesktopDatePicker } from "@mui/x-date-pickers";

interface DatePickerProps {
  label: string;
  value: Dayjs | null; // Date value is either a Dayjs object or null
  onChange: (newValue: Dayjs | null) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
}

const StyledButton = styled(IconButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));

export default function CustomDatePicker({
  label,
  value,
  onChange,
}: DatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DesktopDatePicker"]}>
        <DesktopDatePicker
          label={label}
          value={value}
          onChange={onChange}
          slots={{
            openPickerIcon: CalendarMonthIcon,
            openPickerButton: StyledButton,
          }}
          slotProps={{
            openPickerIcon: { fontSize: "medium" },
            openPickerButton: { color: "primary" },
          }}
          sx={{
            "& .MuiInputBase-root": {
              backgroundColor: "#f5f7f9", // Change input background
              borderRadius: "8px", // Rounded corners
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "none", // Outline color
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "none", // Outline color on hover
            },
            "& .MuiInputLabel-root": {
              color: "#4CAF50", // Label color
            },
            "& .MuiDateCalendar-root": {
              backgroundColor: "#fff", // Calendar background color
            },
            width: "100%",
            color: "black",
            backgroundColor: "#fff",
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}

export {};
